module.exports = __webpack_public_path__ + "img/KinokoTable46.128e3e45.jpg";